import EditModelDataModal from '@/Modules/Base/Components/EditModelDataModal.vue'
import EntityService from '@/Modules/Entity/EntityService.js'

export default {
  methods: {
    openEditDataModal() {
      this.showModal({
        component: EditModelDataModal,
        label: this.__('model-data-modal.edit', { model: this.__('common.entity') }),
        icon: 'database',
        class: 'modal-md',
        meta: {
          data: this.entity.data,
          onSave: data => this.updateData(data)
        },
      })
    },

    updateData(data) {
      return EntityService.updateData(this.entity.id, data)
        .then(() => {
          this.$successToast(this.__('model-data-modal.on-success', { model: this.__('common.entity') }))
          this.refetchResource()
        })
        .catch(error => this.$errorToast(error.response?.data?.message))
    },

    refetchResource() {
      EntityService.show(this.entity.id)
        .then(entity => this.entity = entity)
        .catch(error => this.$errorToast(error.message))
    },
  }
}
